import http from "./http";

export const TicketStatus = {
  PENDING: 0,
  PROCESSING: 1,
  WAIT_USER: 2,
  RESOLVED: 3,
  CLOSED: 4,
  CANCELLED: 5,
};

export const TicketType = {
  PHONE_TASK: 1,
  SMS_CODE: 2,
  PROJECT: 3,
  RECHARGE_WALLET: 4,
  DEV_WITHDRAW: 5,
  ACCOUNT_SECURITY: 6,
  DEVELOPER_API: 7,
  FEATURE_SUGGESTION: 8,
  OTHER: 9,
};

export const RelatedType = {
  NONE: 0,
  SMS_FLOW: 1,
  SMS_TASK: 2,
  SMS_PROJECT: 3,
  APPLY_PROJECT: 4,
  APPLY_EXCLUSIVE: 5,
  EASY_PAY_RECHARGE: 6,
  USDT_RECHARGE: 7,
  ID_CARD: 8,
  WALLET_FLOW: 9,
  DEV_WITHDRAW: 10,
};

export const createTicket = (params) =>
  http.post("/supportTicket/create", params);

export const getMyTickets = (params = {}) =>
  http.post("/supportTicket/myList", params);

export const getMyTicketDetail = (id, beforeMessageId) =>
  http.get("/supportTicket/myDetail", {
    params: { id, ...(beforeMessageId ? { beforeMessageId } : {}) },
  });

export const replyTicket = (params) =>
  http.post("/supportTicket/reply", params);

export const createTicketAttachmentUpload = (params) =>
  http.post("/supportTicket/attachment/createUpload", params);

export const uploadTicketImage = async (target, file, signal) => {
  const response = await fetch(target.uploadUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${target.uploadToken}`,
      "Content-Type": file.type,
    },
    body: file,
    signal,
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.success)
    throw new Error(result.code || "IMAGE_UPLOAD_FAILED");
  return result;
};

export const cancelTicket = (params) =>
  http.post("/supportTicket/cancel", params);

export const closeTicket = (params) =>
  http.post("/supportTicket/close", params);

export const markTicketRead = (ticketId) =>
  http.post("/supportTicket/markRead", { ticketId });

export const getTicketUnreadCount = () =>
  http.get("/supportTicket/unreadCount");

export const getTicketRelatedOptions = (relatedType) =>
  http.get("/supportTicket/relatedOptions", { params: { relatedType } });
